const getters = {
  breadcrumb: state => state.breadcrumb.breadcrumbArray,
  parentId: state => state.breadcrumb.parentId,
}
export default getters